// Fallback content so the site always renders even before the API responds.
export const FALLBACK_FOCACCE = [
  { id: "f1", name: "HONEY", slug: "honey", category: "focacce", image: "/assets/01_honey.jpg",
    ingredients: "Pulled pork artigianale, cheese, cavolo viola, honey mustard", sort_order: 1 },
  { id: "f2", name: "GARLIC", slug: "garlic", category: "focacce", image: "/assets/02_garlic.jpg",
    ingredients: "Pulled pork artigianale, cheese, coleslaw, salsa aioli", sort_order: 2 },
  { id: "f3", name: "CRUNCH", slug: "crunch", category: "focacce", image: "/assets/03_crunch.jpg",
    ingredients: "Pulled pork artigianale, cheese, crocchetta smashed, bacon croccante, salsa barbecue", sort_order: 3 },
  { id: "f4", name: "CHEESE", slug: "cheese", category: "focacce", image: "/assets/04_cheese.jpg",
    ingredients: "Pulled pork artigianale, cheese", sort_order: 4 },
  { id: "f5", name: "SPICY", slug: "spicy", category: "focacce", image: "/assets/05_spicy.jpg",
    ingredients: "Pulled pork artigianale, cheese, jalapeño, salsa UNGRIP", sort_order: 5 },
];

export const FALLBACK_SIDES = [
  { id: "s1", name: "DIRTY FRIES", slug: "dirty-fries", category: "dirty_sides", image: "/assets/06_dirty_fries.jpg", description: "Patatine con cheddar fuso e bacon croccante", sort_order: 1 },
  { id: "s2", name: "CORN DOG", slug: "corn-dog", category: "dirty_sides", image: "/assets/07_corn_dog.jpg", description: "Würstel impanato con ketchup e maionese", sort_order: 2 },
  { id: "s3", name: "CHICKEN TENDERS", slug: "chicken-tenders", category: "dirty_sides", image: "/assets/08_chicken_tenders.jpg", description: "Teneri filetti di pollo speziati e impanati", sort_order: 3 },
  { id: "s4", name: "SPICY BOMBS", slug: "spicy-bombs", category: "dirty_sides", image: "/assets/09_spicy_bombs.jpg", description: "Crocchette di patate ripiene di cheddar, leggermente piccanti", sort_order: 4 },
];

export const FALLBACK_SETTINGS = {
  location: { name: "UNGRIP", address: "Viale di Vittorio 36", city: "Foggia", maps_query: "UNGRIP Viale di Vittorio 36 Foggia" },
  social: { instagram: "https://www.instagram.com/ungripfoggia", tiktok: "https://www.tiktok.com/@ungripfoggia", facebook: "" },
  contact: { email: "ciao@ungrip.it", phone: "" },
  analytics: { ga4_id: "", gtm_id: "", meta_pixel_id: "" },
  links: {
    instagram_url: "https://www.instagram.com/ungripfoggia",
    tiktok_url: "https://www.tiktok.com/@ungripfoggia",
    phone_number: "352 014 3032",
    google_review_url: "https://search.google.com/local/writereview?placeid=ChIJFY-vtgbZORMR8Lmw3-yjYsk",
    whatsapp_number: "352 014 3032",
    whatsapp_message: "Ciao UNGRIP! 👋",
  },
  ordering: {
    glovo_url: "https://glovoapp.com/it/it/foggia",
    justeat_url: "https://www.justeat.it/restaurants-ungrip-foggia/reviews",
  },
};
